import React, { useState } from 'react';
import { TerritorySelect } from './TerritorySelect';
const OPTIONS = [
    { label: 'Fort Wayne', value: 1 },
    { label: 'Kalamazoo', value: 2 },
    { label: 'South Bend', value: 3 }
];
const meta = {
    title: 'Features/Modals/TerritorySelect',
    component: TerritorySelect,
    parameters: {
        docs: {
            description: {
                component: 'Territory assignment for a generic event. An empty selection means every territory. ' +
                    'A territory-restricted author is offered only their own territories and must keep at ' +
                    'least one assigned; territories outside their access stay assigned and are counted ' +
                    'but not listed.'
            }
        }
    }
};
export default meta;
function Controlled({ restricted, initial, error = undefined, lockedReason = undefined }) {
    const [values, setValues] = useState(initial);
    return (React.createElement(TerritorySelect, { options: OPTIONS, restricted: restricted, disabled: !!error || !!lockedReason, lockedReason: lockedReason, values: values, onChange: setValues, error: error }));
}
export const Unrestricted = {
    render: () => React.createElement(Controlled, { restricted: false, initial: [] })
};
export const RestrictedAuthor = {
    render: () => React.createElement(Controlled, { restricted: true, initial: [2] })
};
export const WithHiddenTerritories = {
    render: () => React.createElement(Controlled, { restricted: true, initial: [2, 99] })
};
export const CompanyWideLockedForRestrictedAuthor = {
    render: () => (React.createElement(Controlled, { restricted: true, initial: [], lockedReason: "This event applies to every territory. Only an administrator without territory restrictions can scope it." }))
};
export const LoadFailed = {
    render: () => (React.createElement(Controlled, { restricted: false, initial: [], error: "Territories could not be loaded. Reopen the event to try again." }))
};
